<template v-once>
  <img src="@/assets/icons/zapier_icon.png" alt="zapier icon">
</template>

<script>
export default {
  name: "Zapier",
};
</script>

<style scoped>
</style>